import React from 'react';
import './ProductPreview.css';

const ProductPreview = () => {
  const previews = [
    { 
      title: 'Policy Dashboard',
      description: 'Define and manage governance rules',
      color: '#4F6BFF'
    },
    { 
      title: 'Draft Governance',
      description: 'Review AI-generated content',
      color: '#8B5CF6'
    },
    { 
      title: 'Alignment Analysis',
      description: 'Measure strategic alignment',
      color: '#22C55E'
    },
    { 
      title: 'Audit Log',
      description: 'Track all governance decisions',
      color: '#F59E0B'
    },
  ];

  return (
    <section className="product-preview section" data-testid="product-preview-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title" data-testid="product-preview-title">Platform Overview</h2>
          <p className="section-subtitle">
            Enterprise-grade tools for AI communication governance
          </p>
        </div>
        
        <div className="preview-grid" data-testid="preview-grid">
          {previews.map((preview, index) => (
            <div key={index} className="preview-card" data-testid={`preview-card-${index}`}>
              <div className="preview-frame">
                <div className="preview-header">
                  <div className="preview-dots">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                  <span className="preview-tab">{preview.title}</span>
                </div>
                <div className="preview-content">
                  <div className="preview-placeholder" style={{ borderColor: preview.color }}>
                    <div className="placeholder-icon" style={{ background: preview.color }}>
                      <span>{preview.title.charAt(0)}</span>
                    </div>
                    <p className="placeholder-text">{preview.title}</p>
                    <div className="placeholder-lines">
                      <span style={{ width: '80%', background: `${preview.color}20` }}></span>
                      <span style={{ width: '60%', background: `${preview.color}15` }}></span>
                      <span style={{ width: '70%', background: `${preview.color}10` }}></span>
                    </div>
                  </div>
                </div>
              </div>
              <h3 className="preview-title">{preview.title}</h3>
              <p className="preview-description">{preview.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductPreview;
